export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a lista de estimaciones de cosecha"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar estimación de cosecha"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}